import { Component, signal } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ComponentBuilder } from '../../ComponentBuilder';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { DropdownModule } from 'primeng/dropdown';
import { TTSPlayground, TTSGenerated } from '@dataclouder/ngx-vertex';
import { LessonComponentConfiguration, LessonCompSettings } from '../../lessons.clases';

@Component({
  selector: 'app-speaker-builder',
  templateUrl: './speaker-builder.component.html',
  styleUrls: ['./speaker-builder.component.scss'],
  standalone: true,
  imports: [FormsModule, ReactiveFormsModule, InputTextModule, ButtonModule, DropdownModule, TTSPlayground],
})
export class SpeakerBuilderComponent extends ComponentBuilder {
  override componentName = 'Speaker';
  public tts = signal<TTSGenerated | undefined>(undefined);

  public handleTtsGenerated(event: TTSGenerated): void {
    console.log('TTS generated:', event);
    this.tts.set(event);
  }

  // Update return type and add settings object
  protected override getCode(): LessonComponentConfiguration<LessonCompSettings & { voice: string }> {
    const ttsValue = this.tts();
    if (!ttsValue) {
      // Handle the case where tts is undefined, maybe throw an error or return a default config
      console.error('TTS data is not generated yet.');
      // Depending on requirements, you might return a default/empty config or throw
      return { component: this.questionType, inputs: {} }; // Example: return empty inputs
    }
    const code: LessonComponentConfiguration<LessonCompSettings & { voice: string }> = {
      component: this.questionType,
      inputs: { tts: ttsValue },
    };
    return code;
  }
}
